export default __webpack_public_path__ + "static/media/image-xx99-mark-two.0f14e428.jpg";